import { textColumn } from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { AavoGridColDef } from "src/components/common/dataGrid/types";
import { AddShopOrdersToBatchDataGridApi_ShopOrderDto } from "src/api/generated/erp/production/shopOrderBatch/api/addShopOrdersToBatchDataGridApi.ts";

export const getSirmetAddShopOrdersToBatchDataGridCustomColumns =
	(): AavoGridColDef<AddShopOrdersToBatchDataGridApi_ShopOrderDto>[] => {
		return [
			textColumn({
				field: "tenantCustomColumn1",
				headerName: i18n.t("material"),
				width: 150,
				filterable: false,
				afterColumn: "configurationOrPartDescription",
				valueGetter: (_, row) =>
					row.tenantCustomColumn1 == null ? "" : JSON.parse(row.tenantCustomColumn1)[0],
			}),
		];
	};
